__turbopack_context__.v({
  "error": "styles-module___qo5xa__error",
  "list": "styles-module___qo5xa__list",
  "paginationButton": "styles-module___qo5xa__paginationButton",
  "paginationButtonContainer": "styles-module___qo5xa__paginationButtonContainer",
});
